define('companiesDetailBodySubaccountRowView',[
  'module',
  'marionette',
  'underscore',
  'jquery',
  'template!companiesDetailBodySubaccountRowView'
], function (
  module,
  Marionette,
  _,
  $,
  Tpl
) {
  'use strict';

  module.exports = Marionette.ItemView.extend({
    template: Tpl,
    tagName: 'tr',
    className: 'subaccount-row clickable',

    events: {
      'click': 'onClick',
      'change .js-select': 'onToggle'
    },

    // A click on the row opens the customer; the checkbox only picks it.
    onClick: function (e) {
      if ($(e.target).is(':checkbox') || $(e.target).closest('td.sel').length) { return; }
      this.trigger('selected');
    },

    onToggle: function (e) {
      this.model.set('selected', !!e.currentTarget.checked);
      this.trigger('toggled');
    },

    serializeData: function () {
      var data = this.model.toJSON();
      return {
        selected: !!data.selected,
        endUserId: data.endUserId || data.code || '',
        name: data.name || '',
        firstName: data.firstName || '',
        lastName: data.lastName || '',
        email: data.email || '',
        city: data.city || ''
      };
    }
  });
});

